<template>
  <popup-modal ref="popup" @click="_cancel">
    <!-- Main modal -->
    <div class="modal-content" @click.stop>
      <span class="close" @click="_cancel">
        <i class="fas fa-times text-2xl text-white"></i>
      </span>
      <img :src="selectedImage" alt="Full Size" class="modal-image" />
    </div>
  </popup-modal>
</template>
<script>
import PopupModal from "./PopupModal.vue";

export default {
  name: "ConfirmDialogue",

  components: { PopupModal },

  data: () => ({

    selectedImage: "",
  }),

  methods: {
    show(opts = {}) {
      this.selectedImage = opts;

      this.$refs.popup.open();
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    _confirm() {
      this.$refs.popup.close();
      this.resolvePromise(true);
    },

    _cancel() {
      this.$refs.popup.close();
      this.resolvePromise(false);
      // Or you can throw an error
      // this.rejectPromise(new Error('User canceled the dialogue'))
    },
  },
};
</script>
<style scoped>
.modal-content {
  position: relative;
  max-width: 95vw;
  max-height: 95vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}

.modal-image {
  max-width: 100%;
  max-height: 95vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.close {
  position: absolute;
  top: -15px;
  right: -15px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background-color 0.2s ease;
}

.close:hover {
  background-color: rgba(0, 0, 0, 0.9);
}

.close i {
  font-size: 1.25rem;
}
</style>
